import Footer from "../components/Footer/Footer";
import trainer1 from '../images/trainers/trainer1.png';
import GirlRedBg from "../images/trainers/trainer-bg.png";
import GirlText from "../images/who-we-are/girl-side-text.png";
import GirlWind from "../images/who-we-are/wind.png";
import TitleRed from "../images/who-we-are/title-bg.svg";
import MainButton from "../components/MainButton";
import Img3 from "../images/AboutPage/Gym.png";
import Img4 from "../images/AboutPage/Cardio.webp";
import Img5 from "../images/AboutPage/CrossFit .jpg";
import Img6 from "../images/AboutPage/Aerobics-.jpg";


function About() {
  return (
    <>
      <section className="login-section">
        <div className="login-banner relative justify-center flex">
          <h1 className="text-white absolute bottom-[25px] text-[3rem] font-bold">
            About Us
          </h1>
        </div>
        <div className="container page-padding py-[5rem]">
          <div className="grid grid-cols-[1fr_1fr] h-[60rem] md1000:grid-cols-1">
            {/* title div -- */}
            <div className="flex flex-col !text-left relative items-right justify-center md1000:items-center md1000:!text-center">
              <p className="text-white relative z-10 text-[15px] uppercase font-bold mb-8 ml-20 md1000:ml-3 ">
                who we are !!
              </p>
              <img
                src={TitleRed}
                alt="text_bg"
                className="w-[21rem] absolute top-[120px] min450:top-[84px] min375:top-[68px]"
              />

              <h2 className="text-[3.6rem] max-w-[53rem] font-bold mb-4">
                We Will Give You Strength and Health
              </h2>
              <p className="text-[#646464] font-medium text-[15px] max-w-[50rem] ">
                At HIFI Fitness, 
                We're here to help you achieve your fitness goals. Our trainers will create a personalized workout plan tailored to your needs, guiding you every step of the way toward the body you've always wanted.
              </p>
              <MainButton
                color={`!text-white`}
                bg={`bg-[#ff0336]`}
                goTo="/contact"
                text="contact us"
                arrowColor={`!text-white`}
                cN="pricing-cta blog-cta"
              />
            </div>
            {/*  */}
            <div className="relative w-[80%] -top-[90px] left-[40px] md1000:hidden">
              <img
                src={trainer1}
                alt="Trainer_abt"
                className="girl-running"
              />
              <img src={GirlRedBg} alt="bg-red" className="boy-bg" />
              <img src={GirlText} alt="bg-text" className="girl-text" />
              <img src={GirlWind} alt="bg-wind" className="girl-wind" />
            </div>
          </div>
          {/*  */}



          <div className="mt-[10rem]">
            <div className="grid grid-cols-2 grid-rows-2 w-full min620:grid-cols-1">
            <div className="w-full bg-white h-[43rem] flex flex-col justify-start items-center px-[100px] min800:px-[10px]">
              <svg className="w-[9rem] h-auto" viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.3812 3.41487L10.1103 1.2853C10.0359 1.21502 9.9475 1.15924 9.85006 1.12117C9.75262 1.0831 9.64811 1.0635 9.54255 1.0635C9.437 1.0635 9.33248 1.0831 9.23505 1.12117C9.13761 1.15924 9.04917 1.21502 8.97484 1.2853C8.82591 1.4258 8.74232 1.61585 8.74232 1.81395C8.74232 2.01204 8.82591 2.20209 8.97484 2.34259L10.67 3.93226L4.1932 10.006L2.49804 8.41634C2.34822 8.27668 2.14556 8.19829 1.93432 8.19829C1.72307 8.19829 1.52041 8.27668 1.3706 8.41634C1.29565 8.48605 1.23616 8.56898 1.19557 8.66036C1.15497 8.75173 1.13407 8.84974 1.13407 8.94873C1.13407 9.04772 1.15497 9.14573 1.19557 9.2371C1.23616 9.32848 1.29565 9.41141 1.3706 9.48112L3.61748 11.5882L5.86437 13.6953C5.93843 13.7661 6.02674 13.8225 6.12419 13.8611C6.22164 13.8997 6.3263 13.9198 6.43209 13.9202C6.59091 13.9211 6.74641 13.8776 6.87876 13.7952C7.01111 13.7129 7.11432 13.5955 7.17522 13.4579C7.23612 13.3204 7.25197 13.1689 7.22073 13.0229C7.18949 12.8769 7.11258 12.7429 6.99981 12.638L5.32864 11.0708L11.8054 4.99704L13.5006 6.58672C13.5751 6.65614 13.6636 6.71111 13.7608 6.74849C13.858 6.78587 13.9621 6.80494 14.0671 6.80459C14.1722 6.80424 14.2762 6.78449 14.3731 6.74646C14.47 6.70844 14.558 6.65288 14.632 6.58297C14.7061 6.51305 14.7647 6.43015 14.8045 6.33899C14.8444 6.24783 14.8647 6.1502 14.8644 6.05167C14.864 5.95315 14.8429 5.85566 14.8024 5.76476C14.7618 5.67387 14.7026 5.59136 14.628 5.52193L12.3812 3.41487ZM1.3706 11.5957C1.22003 11.4545 1.01581 11.3752 0.802876 11.3752C0.58994 11.3752 0.385725 11.4545 0.235157 11.5957C0.0845885 11.7369 1.5865e-09 11.9284 0 12.1281C-1.5865e-09 12.3278 0.0845885 12.5193 0.235157 12.6605L2.49804 14.7825C2.57275 14.852 2.66136 14.907 2.75878 14.9443C2.85621 14.9816 2.96052 15.0006 3.06576 15C3.17099 15.0006 3.27531 14.9816 3.37273 14.9443C3.47015 14.907 3.55876 14.852 3.63348 14.7825C3.70842 14.7128 3.76791 14.6299 3.8085 14.5385C3.8491 14.4471 3.87 14.3491 3.87 14.2501C3.87 14.1512 3.8491 14.0531 3.8085 13.9618C3.76791 13.8704 3.70842 13.7875 3.63348 13.7178L1.3706 11.5957ZM15.7635 2.34259L13.5006 0.220523C13.426 0.150609 13.3375 0.0951496 13.2401 0.0573121C13.1427 0.0194747 13.0383 0 12.9329 0C12.8274 0 12.723 0.0194747 12.6256 0.0573121C12.5282 0.0951496 12.4397 0.150609 12.3652 0.220523C12.2906 0.290438 12.2315 0.373439 12.1911 0.464786C12.1508 0.556134 12.13 0.65404 12.13 0.752914C12.13 0.851788 12.1508 0.949694 12.1911 1.04104C12.2315 1.13239 12.2906 1.21539 12.3652 1.2853L14.628 3.40737C14.7024 3.47765 14.7908 3.53344 14.8882 3.5715C14.9857 3.60957 15.0902 3.62917 15.1958 3.62917C15.3013 3.62917 15.4058 3.60957 15.5033 3.5715C15.6007 3.53344 15.6891 3.47765 15.7635 3.40737C15.8384 3.33766 15.8979 3.25473 15.9385 3.16335C15.9791 3.07198 16 2.97397 16 2.87498C16 2.77599 15.9791 2.67798 15.9385 2.58661C15.8979 2.49523 15.8384 2.4123 15.7635 2.34259Z" fill="#ff0336"></path>
              </svg>
               <h2 className="text-[36px] font-bold mt-3">Gym</h2>
                <p className="text-[16px] font-medium text-[#646464] mt-5">
                  <b>Elevate Your Strength with Us!</b> <br />
                Our program boosts your strength and confidence through dynamic exercises. Whether you're new or experienced, our expert trainers offer personalized workouts to meet your goals. It's more than just lifting weights—it's about achieving your full potential. Join us and transform your fitness journey today!
                </p>
                
              </div>
              {/*  */}
              <div className="w-full bg-white h-[43rem] flex flex-col justify-center items-center px-[100px] min800:px-[10px]">
              <img
                src={Img3}
                alt="about_img"
                className="w-[65%] h-[65%] object-cover bg-center"
              />


              </div>
              {/*  */}



              <div className="w-full bg-white h-[43rem] flex flex-col justify-center items-center px-[100px] min800:px-[10px]">
                <img
                  src={Img4}
                  alt="about_img"
                  className="w-[65%] h-[65%] object-cover bg-center"
                />
                
              </div>
              {/*  */}
              <div className="w-full bg-white h-[43rem] flex flex-col justify-start items-center px-[100px] min800:px-[10px]">
                <svg className="w-[9rem] h-auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#ff0336"></path>
                </svg>

                <h2 className="text-[36px] font-bold mt-3">Cardio</h2>
                <p className="text-[16px] font-medium text-[#646464] mt-5">
                  <b>Boost Your Fitness with Cardio!</b> <br />Get ready to supercharge your fitness with our invigorating cardio program! Our dynamic sessions feature a series of high-energy moves, lasting 20 to 30 minutes, designed to boost your endurance and burn calories efficiently. Perfect for all fitness levels, our expert trainers will keep you motivated and moving, ensuring every workout is a step toward a healthier, more energetic you. Dive in and elevate your cardio game today!
                </p>
              </div>


              <div className="w-full bg-white h-[43rem] flex flex-col justify-start items-center px-[100px] min800:px-[10px]">
              <svg className="w-[9rem] h-auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 12l-2-2v-4h-1v4l-2 2-2-2v-4h-1v4l-2 2-2-2v-4h-1v4l-2 2-2-2v-4h-1v4l-2 2v1h24v-1l-2-2z" fill="#ff0336"></path>
              </svg>
                <h2 className="text-[36px] font-bold mt-3">Cross Fit</h2>
                <p className="text-[16px] font-medium text-[#646464] mt-5">
                  <b>Ignite Your Power with CrossFit!</b><br />Dive into our exhilarating CrossFit sessions, where high-intensity meets fun! Our program combines weightlifting and bodyweight exercises to build strength, agility, and overall fitness. Push your limits, achieve peak performance, and transform your workout routine. Join us and experience the ultimate fitness challenge!
                </p>
              </div>
              {/*  */}
              <div className="w-full bg-white h-[43rem] flex flex-col justify-center items-center px-[100px] min800:px-[10px]">
                <img
                  src={Img5}
                  alt="about_img"
                  className="w-[65%] h-[65%] object-cover bg-center"
                />
                
              </div>


              <div className="w-full bg-white h-[43rem] flex flex-col justify-center items-center px-[100px] min800:px-[10px]">
                <img
                  src={Img6}
                  alt="about_img"
                  className="w-[65%] h-[65%] object-cover bg-center"
                />
              
              </div>
              {/*  */}
              <div className="w-full bg-white h-[43rem] flex flex-col justify-start items-center px-[100px] min800:px-[10px]">
                <svg className="w-[9rem] h-auto" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ff0336">
                  <path d="M12 2a2 2 0 110 4 2 2 0 010-4zm0 4.5c1.33 0 2.55.47 3.54 1.26l1.9-1.9a1 1 0 011.41 1.41l-1.9 1.9c.79.99 1.26 2.21 1.26 3.54v5a1 1 0 11-2 0v-5a4 4 0 10-8 0v5a1 1 0 11-2 0v-5c0-1.33.47-2.55 1.26-3.54l-1.9-1.9a1 1 0 011.41-1.41l1.9 1.9c.99-.79 2.21-1.26 3.54-1.26zm-4.5 13a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm9 0a1.5 1.5 0 110 3 1.5 1.5 0 010-3z"></path>
                </svg>


                <h2 className="text-[36px] font-bold mt-3">Aerobics</h2>
                <p className="text-[16px] font-medium text-[#646464] mt-5">
                  <b>Get Moving with Aerobics!</b><br />Join our vibrant aerobics classes and dance your way to better cardiovascular fitness! Enjoy rhythmic, high-energy exercises set to upbeat music that boost your endurance and make fitness fun. Feel the rhythm and elevate your workout experience!
                </p>
              </div>


            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default About;
